interface ITICK_PROPS {
  width?: number;
  height?: number;
  className?: string;
  strokeColor?: string;
  strokeWidth?: number;
}

export const Tick = ({
  width = 13,
  height = 8,
  className = '',
  strokeColor = '#16CC65',
  strokeWidth = 2,
}: ITICK_PROPS): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.5 3.22247L4.27778 6.55618L11.5 1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};
